import * as actions from './portfolio.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { PortfolioModel } from '@smarttask-common/src/lib/models/Portfolio/Core/PortfolioModel';

export const portfolioAdapter = createEntityAdapter<PortfolioModel>({
    selectId: (x) => x.portfolio_id,
});
export interface PortfolioState extends EntityState<PortfolioModel> {
    selected_portfolio_id: string;
}

export const initialState: PortfolioState = portfolioAdapter.getInitialState({
    selected_portfolio_id: undefined,
});

export function PortfolioReducers(state: PortfolioState = initialState, action: actions.PortfolioActions) {
    switch (action.type) {
        case actions.PortfolioActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_portfolio_id: action.selected_portfolio_id };
            return state;

        case actions.PortfolioActionTypes.ADD_PORTFOLIO:
            return portfolioAdapter.addOne(action.portfolio, state);

        case actions.PortfolioActionTypes.ADD_PORTFOLIOS:
            return portfolioAdapter.addMany(action.portfolios, state);

        case actions.PortfolioActionTypes.UPSERT_PORTFOLIO:
            return portfolioAdapter.upsertOne(action.portfolio, state);

        case actions.PortfolioActionTypes.UPSERT_PORTFOLIOS:
            return portfolioAdapter.upsertMany(action.portfolios, state);

        case actions.PortfolioActionTypes.UPDATE_PORTFOLIO:
            return portfolioAdapter.updateOne(action.portfolio, state);

        case actions.PortfolioActionTypes.UPDATE_PORTFOLIOS:
            return portfolioAdapter.updateMany(action.portfolios, state);

        case actions.PortfolioActionTypes.DELETE_PORTFOLIO:
            // if(state.selectedPortfolioId == action.id){
            //   state.selectedPortfolioId = undefined;
            // }
            return portfolioAdapter.removeOne(action.id, state);

        case actions.PortfolioActionTypes.DELETE_PORTFOLIOS:
            // if(action.ids.indexOf(state.selectedPortfolioId) > -1){
            //   state.selectedPortfolioId = undefined;
            // }
            return portfolioAdapter.removeMany(action.ids, state);

        case actions.PortfolioActionTypes.DELETE_ALL_PORTFOLIOS:
            return portfolioAdapter.removeMany(action.ids, state);

        case actions.PortfolioActionTypes.DELETE_ALL:
            return portfolioAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getPortfolioState = createFeatureSelector<PortfolioState>('portfolio');

export const { selectIds, selectEntities, selectAll, selectTotal } = portfolioAdapter.getSelectors(getPortfolioState);

const getSelectedPortfolioIdState = (state: PortfolioState) => {
    return state.selected_portfolio_id;
};
export const getSelectedPortfolioId = createSelector(getPortfolioState, getSelectedPortfolioIdState);

export const getSelectedPortfolio = createSelector(getPortfolioState, (state: PortfolioState) => {
    if (state.selected_portfolio_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_portfolio_id];
});
